import { useEffect } from 'react';

// Filter out email addresses and potentially malicious input (TG-2254).
const DISALLOWED_CHARACTERS = new RegExp(/[@<>=;]/);

/**
 *
 * @param {string} searchTerm
 * @param {() => void} callback
 */
export default function useSearchTermInvalidCallback(searchTerm, callback) {
  useEffect(() => {
    if (searchTerm && DISALLOWED_CHARACTERS.test(searchTerm)) {
      callback();
    }
  }, [searchTerm]);
}
